<template>
  <custom-callout
    border-color="secondary-3"
    class-main="mt-2 rounded"
    :has-toggle="false"
    :opened="false"
  >
    <div class="row py-1 mr-md-0 align-items-center">
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Año Fiscal:</div>
        <div class="color-black font-16">
          {{ value.academicYearName }}
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Estatus:</div>
        <div class="d-flex align-items-center">
          <em
            class="fas fa-circle font-13 mr-1"
            :class="`color-${statusColor}`"
          />
          <div class="color-black font-16">
            {{ value.statusName }}
          </div>
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Número de Solicitud:</div>
        <div class="color-black font-16">
          {{ value.requestNumber | empty }}
        </div>
      </div>
      <div
        class="col col-sm col-12 mt-3 mt-md-0 d-flex align-items-center justify-content-end"
      >
        <drop-down class="ml-2" :items="actionItems" />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import requestBiddingStatuses from '@/utils/constants/requestBiddingStatuses.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

const PRINT_CONTRACT_PERMISSION = 'rempro.providers.provider.printcontract';

export default {
  name: 'BiddingRequestRow',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    DropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    statusColor() {
      switch (this.value.statusId) {
        case requestBiddingStatuses.Pending:
          return 'secondary-24';
        case requestBiddingStatuses.Approved:
          return 'green-light';
        case requestBiddingStatuses.Denied:
          return 'brown';
        default:
          return null;
      }
    },
    actionItems() {
      return [
        {
          label: 'Entrar',
          icon: 'fas fa-file-import color-green',
          click: () => this.$emit('on-enter'),
        },
        {
          label: 'Imprimir',
          icon: 'fas fa-print color-green',
          visible: this.hasPrintPermission,
          border: 'top',
          click: () => this.$emit('on-print'),
        },
        {
          label: 'Registro de Proveedor Activo',
          icon: 'fas fa-print color-green',
          visible:
            this.value.statusId == requestBiddingStatuses.Approved &&
            this.value.academicYearId == this.currentAcademicYearId,
          border: 'top',
          click: () => this.$emit('on-print-registry'),
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-times-circle color-red',
          visible: this.hasDeletePermission,
          border: 'top',
          click: () => this.$emit('on-delete'),
        },
      ];
    },
    hasDeletePermission() {
      return this.userHasPermissions('menu.rempro.view.removebiddingrequest');
    },
    hasPrintPermission() {
      return this.userHasPermissions(PRINT_CONTRACT_PERMISSION);
    },
  },
};
</script>
